module.exports = __webpack_public_path__ + "img/LAPTOP.ea6fb6f9.svg";